'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dGrocery$002dItem from "./mealorama.-Grocery-Item.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItem$() {
}
export { $c_Lmealorama_GroceryItem$ as $c_Lmealorama_GroceryItem$ };
$p = $c_Lmealorama_GroceryItem$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItem$;
/** @constructor */
function $h_Lmealorama_GroceryItem$() {
}
export { $h_Lmealorama_GroceryItem$ as $h_Lmealorama_GroceryItem$ };
$h_Lmealorama_GroceryItem$.prototype = $p;
$p.m = (function() {
  return "GroceryItem";
});
$p.aSe = (function(x$0) {
  return new $j_mealorama$002e$002dGrocery$002dItem.$c_Lmealorama_GroceryItem(x$0.g(0), x$0.g(1), x$0.g(2), x$0.g(3), (!(!x$0.g(4))));
});
var $d_Lmealorama_GroceryItem$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItem$, "mealorama.GroceryItem$", ({
  FL: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_GroceryItem$ as $d_Lmealorama_GroceryItem$ };
var $n_Lmealorama_GroceryItem$;
function $m_Lmealorama_GroceryItem$() {
  if ((!$n_Lmealorama_GroceryItem$)) {
    $n_Lmealorama_GroceryItem$ = new $c_Lmealorama_GroceryItem$();
  }
  return $n_Lmealorama_GroceryItem$;
}
export { $m_Lmealorama_GroceryItem$ as $m_Lmealorama_GroceryItem$ };
//# sourceMappingURL=mealorama.-Grocery-Item$.js.map
